import { select, Store } from '@ngrx/store';
import { Label } from 'src/app/models/Label';
import * as fromMessages from '../../../messagingV3/legacy/reducers';
import * as fromSettings from '../../../settings/reducers';
import * as fromDashboard from '../../reducers';
import * as MessageActions from '../../../messagingV3/legacy/actions/message-ui.actions';
import { NavigationService } from '../../../core/services/navigation.service';
var DashboardFoldersComponent = /** @class */ (function () {
    function DashboardFoldersComponent(_store, _navigationService) {
        this._store = _store;
        this._navigationService = _navigationService;
        this.labels$ = this._store.pipe(select(fromMessages.getLabelNames));
        this.sectionText$ = this._store.pipe(select(fromSettings.getSectionTranslations('Dashboard')));
        this.summary$ = this._store.pipe(select(fromDashboard.getDashboardSummary));
        this.messagingSummary$ = this._store.pipe(select(fromMessages.getMessagingSummary));
    }
    DashboardFoldersComponent.prototype.goToMessagesByLabel = function (label) {
        // set label of messages to view
        this._store.dispatch(new MessageActions.ApplyFilter(label.toLowerCase()));
        // then open messages
        this._navigationService.navigate(['/messages']);
    };
    DashboardFoldersComponent.prototype.goToMessagesByType = function (messageTypeId) {
        this._store.dispatch(new MessageActions.ApplyMessageTypeFilter(new Label({
            messageTypeId: messageTypeId,
            displayName: '',
            filter: '',
            isGroup: false
        })));
        // then open messages
        this._navigationService.navigate(['/messages']);
    };
    return DashboardFoldersComponent;
}());
export { DashboardFoldersComponent };
